import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IChatV2ComponentChunk } from '@shared/interfaces/ai-executor.interface';

@Component({
  selector: 'app-ai-chat-section',
  template: `
    <div class="ai-chat-section-divider mt-3 mb-2">
      <h2 class="ai-chat-section-title mb-0">{{ title }}</h2>
      <p *ngIf="description" class="ai-chat-section-description text-muted small mt-1 mb-0">{{ description }}</p>
    </div>
  `,
  styleUrls: ['./ai-chat-section.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class AiChatSectionComponent {
  @Input() public chunk: IChatV2ComponentChunk;

  public static serialize(data: Record<string, unknown>): string {
    const title = (data['title'] as string) ?? '';
    const description = (data['description'] as string) ?? '';

    const lines: string[] = [];
    if (title) {
      lines.push(`> # ${title}`);
    }
    if (description) {
      lines.push(`> ${description}`);
    }

    return lines.join('\n');
  }

  public get title(): string {
    return (this.chunk?.data?.['title'] as string) ?? '';
  }

  public get description(): string {
    return (this.chunk?.data?.['description'] as string) ?? '';
  }
}
